import { lazy, Suspense } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { AuthProvider } from './hooks/useAuth'
import { Header } from './components/Header'
import { Footer } from './components/Footer'
import { DemoBanner } from './components/DemoBanner'
// import { StatusIndicator } from './components/StatusIndicator'
import { AuthRedirect } from './components/AuthRedirect'
import { HomePageNew } from './pages/HomePageNew'

// Importações lazy para otimização
const ModelsPage = lazy(() => import('./pages/ModelsPage'))
const ProfilePage = lazy(() => import('./pages/ProfilePage'))
const ClientProfilePage = lazy(() => import('./pages/ClientProfilePage'))
const LoginPage = lazy(() => import('./pages/LoginPage'))
const RegisterPage = lazy(() => import('./pages/RegisterPage'))
const WelcomePage = lazy(() => import('./pages/WelcomePage'))
const TokensPage = lazy(() => import('./pages/TokensPage'))
const ModelDashboard = lazy(() => import('./pages/ModelDashboard'))
const DebugPage = lazy(() => import('./pages/DebugPage'))
const TermsPage = lazy(() => import('./pages/TermsPage'))
const PrivacyPage = lazy(() => import('./pages/PrivacyPage'))
const HelpPage = lazy(() => import('./pages/HelpPage'))
const ContactPage = lazy(() => import('./pages/ContactPage'))

function App() {
  return (
    <AuthProvider>
      <Router
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true
        }}
      >
        <div className="min-h-screen bg-gray-900 flex flex-col">
          <DemoBanner />
          <Header />
          
          <main className="flex-1">
            <AuthRedirect>
              <Suspense 
                fallback={
                  <div className="flex items-center justify-center min-h-[400px]">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-pink-500"></div>
                  </div>
                }
              >
                <Routes>
                  <Route path="/" element={<HomePageNew />} />
                  <Route path="/models" element={<ModelsPage />} />
                  <Route path="/profile/:id" element={<ProfilePage />} />
                  <Route path="/client-profile" element={<ClientProfilePage />} />
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/register" element={<RegisterPage />} />
                  <Route path="/welcome" element={<WelcomePage />} />
                  <Route path="/tokens" element={<TokensPage />} />
                  <Route path="/model-dashboard" element={<ModelDashboard />} />
                  <Route path="/debug" element={<DebugPage />} />
                  <Route path="/terms" element={<TermsPage />} />
                  <Route path="/privacy" element={<PrivacyPage />} />
                  <Route path="/help" element={<HelpPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  
                  {/* Fallback para rotas não encontradas */}
                  <Route path="*" element={
                    <div className="flex items-center justify-center min-h-[400px] text-center">
                      <div>
                        <h1 className="text-4xl font-bold text-white mb-4">404</h1>
                        <p className="text-gray-400 mb-6">Página não encontrada</p>
                        <a href="/" className="btn-primary">
                          Voltar ao Início
                        </a>
                      </div>
                    </div>
                  } />
                </Routes>
              </Suspense>
            </AuthRedirect>
          </main>

          <Footer />
          {/* <StatusIndicator /> */}
        </div>
      </Router>
    </AuthProvider>
  )
}

export default App
